// extracted by mini-css-extract-plugin
export default {"details":"details_B4FW","isBrowser":"isBrowser_Cof9","collapsibleContent":"collapsibleContent_VYua"};